var postGrid = {

    filterPosts: function() {
        let $form = $('.js-posts-filters');
        let $action = $form.attr('action');
        // On select change reload page with new query string
        $form.find('select').on('change', function() {
            let $formData = $('.js-posts-filters').serialize();
            window.location.href = $action + '?' + $formData;
        });
    },

	init: function() {
		var self = this;

        self.filterPosts();
	}

};

module.exports = postGrid;